import { render, staticRenderFns } from "./Import.vue?vue&type=template&id=e6020750&scoped=true"
import script from "./Import.vue?vue&type=script&lang=js"
export * from "./Import.vue?vue&type=script&lang=js"
import style0 from "./Import.vue?vue&type=style&index=0&id=e6020750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6020750",
  null
  
)

export default component.exports